module.exports = __webpack_public_path__ + "images/line_friend_lp/step3-number-icon_054b25b48bc3bedc2631a08dcb797e1c.png";